import React from 'react';
import { Drag } from 'components/ui/Icon/Streamline';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const MatchingChoicePreview = ({ match }) => {
  return (
    <div className="DragCard d-f ai-c mb-12 p-8">
      <Drag className="fs-0" />
      <Text className="ml-8" variant={TEXT_VARIANTS.MANTLE_BODY}>
        {match.match}
      </Text>
    </div>
  );
};

export default MatchingChoicePreview;
